var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isHx)?_c('HxHomeContent'):_vm._e(),(_vm.isMask)?_c('MaskHomeContent'):_vm._e(),(_vm.is8v)?_c('BvHomeContent'):_vm._e(),(_vm.isbitda)?_c('BitdaHomeContent'):_vm._e(),(_vm.isDefault)?_c('HomeContent'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }